module.exports = __webpack_public_path__ + "img/finished.941670e6.jpg";